(function($, undefined) {
	
	'use strict';	
	var imagePreviewCtn;
	var formValidator;

	var addTravelBookPage = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var userId = $('[name=user-id]', form).length > 0 ? $('[name=user-id]', form).val() : null;
			var title = 'Titre de la page';
			var pageData = null;

			var d = new Date();

			var month = d.getMonth()+1;
			var day = d.getDate();

			var formattedDate = ((''+day).length<2 ? '0' : '') + day + '/' +
			    ((''+month).length<2 ? '0' : '') + month + '/' +
			    d.getFullYear().toString().substr(-2);
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'travel-book-page',
				field2: title,
				field3: pageData,
				field5: formattedDate,
				field6: userId
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					if (response.responseText.indexOf('success') !== -1) {
						var pageId = (response.responseText).substring(8);
						location.replace(location+"?gid="+pageId);
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		
		$('.add-page-btn').on('click', addTravelBookPage);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
